module.exports = __webpack_public_path__ + "img/duckroundtrans.08f251bb.png";